/// <reference path="../../../../../../typings/index.d.ts" />
/// <reference path="../../controls.module.ts" />
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../../../../components/models/meevo.model.custom.ts"/>


module Meevo.Components.Controls {

    import Dictionary = _.Dictionary;
    import IReportControlCriteria = Meevo.Plugins.Reports.IReportControlCriteria;
    import IReportControlScope = Meevo.Plugins.Reports.IReportControlScope;

    export class Ma075Criteria implements IReportControlCriteria {

        public criteria: Dictionary<any>;

        constructor(private scope: IReportControlScope) {
            this.criteria = {
                DepartmentList: null
            };

            scope['selectedDepartment'] = null;

            scope.$watch('selectedDepartment', this.updateCriteria.bind(this));
        }

        private updateCriteria(newValue: string, oldValue: string) {
            if (newValue === oldValue) return;

            angular.extend(this.criteria, {
                DepartmentList: this.scope['selectedDepartment']
            });
        }
    }

}
